module.exports = __webpack_public_path__ + "assets/img/Aussie-Broadband-eBook-w960.6bdd1008.webp";